import React, { createContext } from 'react'

export const AuthContext = createContext()
class AuthContextProvider extends React.Component{
    state = {
        isLoggedIn: false,
    }
    processLogin = () => {
        this.setState({isLoggedIn: true})
        return(true)
    };
    render(){
        return(
            <AuthContext.Provider value={{ ...this.state, processLogin: this.processLogin }}>
                { this.props.children }
            </AuthContext.Provider>
        )
    }
}
export default AuthContextProvider
